import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { CancelText } from '../constants';
import { modalProps } from './action-modal.props';
import { Cross, InfoIcon } from '../../assets/images';
import StyledTooltip from '../tooltip';

function ActionModal({
  open,
  modalTitle,
  modalDesc,
  className,
  children,
  modalLogo,
  saveData,
  resetData,
  confirmButtonText,
  disableSaveButton,
  isInfoIcon,
  infoIconTitle,
  isActionsNeeded,
  style,
  cancelButtonText,
  cancelButtonNeeded = true,
}: modalProps) {
  const handleClose = () => resetData && resetData();
  const isActionsRequired = isActionsNeeded !== false;

  let cancelButtonTxt;
  if (cancelButtonText) {
    cancelButtonTxt = cancelButtonText;
  } else {
    cancelButtonTxt = CancelText;
  }

  return (
    <div className={open ? '' : 'hidden'}>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className={`scroller absolute flex flex-col top-1/2 left-1/2 border-0 rounded-xl transform -translate-x-1/2 -translate-y-1/2  bg-white shadow-md overflow-auto max-h-[80%] g-y-5 justify scrollbar-hide ${
            className
          }`}
        >
          <div className="flex p-[20px] pb-[24px] gap-3 flex-col" style={style}>
            {/* Modal introduction */}
            {modalLogo && modalTitle && (
              <div className="flex items-start justify-between">
                <div className="flex gap-[20px] items-center">
                  <div className="flex w-12 h-12 bg-[#e0f1f8] rounded-full items-center justify-center flex-shrink-0">
                    <img src={modalLogo} alt="modal logo" />
                  </div>
                  <div className="flex flex-col">
                    <span
                      id="modal-modal-title"
                      className="flex gap-2 text-base text-[#101828] font-medium"
                    >
                      {modalTitle}
                      {isInfoIcon && (
                        <StyledTooltip title={infoIconTitle || ''} placement="bottom">
                          <img src={InfoIcon} alt="information icon" />
                        </StyledTooltip>
                      )}
                    </span>
                    <span
                      id="modal-modal-title"
                      className="text-base text-[#667085] font-normal text-wrap"
                    >
                      {modalDesc}
                    </span>
                  </div>
                </div>
                <button type="button" onClick={handleClose} className="hover:cursor-pointer">
                  <img src={Cross} className="w-3 h-3" alt="cross icon" />
                </button>
              </div>
            )}
            {children}
          </div>
          {/* Actions Container */}
          {isActionsRequired && (
            <div className="flex flex-row border-t-[#D4D4D4] border-t-[1px] bg-[#F9FAFB]">
              <div className="flex p-4 w-full gap-[12px]">
                <div className="w-[50%]">
                  {cancelButtonNeeded ? (
                    <button
                      type="button"
                      className="border-[1px] bg-[#FFFFFF] border-[#E4E4E7] w-full py-2 text-[#6A6A6A] rounded-lg hover:bg-[#F48B00] hover:text-white hover:border-[#F48B00]"
                      onClick={handleClose}
                    >
                      {cancelButtonTxt}
                    </button>
                  ) : (
                    <div className="w-full" />
                  )}
                </div>
                <div className="w-[50%]">
                  <button
                    type="button"
                    className={`w-full py-2 text-white rounded-lg border-[1px] transition-colors duration-200
                      ${
                        disableSaveButton
                          ? 'bg-gray-300 border-gray-300 hover:bg-gray-300 cursor-not-allowed'
                          : 'bg-[#0A8BC7] border-[#0A8BC7] hover:bg-[#247ba4]'
                      }
                    `}
                    onClick={saveData}
                    disabled={disableSaveButton}
                  >
                    {confirmButtonText}
                  </button>
                </div>
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}

export default ActionModal;
